<template>
    <img
        :src="isLazy ? placeholderUrl : src"
        :data-src="isLazy ? src : ''"
        v-bind="$attrs"
        @error="onError"
    />
</template>

<script>
import lozad from "lozad";
import $ from "jquery";

export default {
    name: "app-image",

    props: {
        url: {
            type: String,
            required: true
        },

        isLocal: {
            type: Boolean,
            default: false
        },

        tryWebp: {
            type: Boolean,
            default: true
        },

        lazy: {
            type: Boolean,
            default: false
        },

        placeholder: {
            type: String,
            default: "16:9",
            validator: prop => ["16:9", "1:1"].includes(prop)
        },

        noPlaceholder: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            errorLoading: false,
            isLazy: this.lazy,
            observer: null
        };
    },

    mounted() {
        if (this.isLazy) {
            this.observer = lozad(this.$el);
            this.observer.observe();
        }
    },

    computed: {
        src() {
            let src = this.url;

            if (this.tryWebp && this.$supportsWebp && !this.errorLoading) {
                src += ".webp";
            }

            if (this.isLocal) {
                return require(`@/assets/img/${src}`);
            }

            return src;
        },

        placeholderUrl() {
            if (this.noPlaceholder) return "";

            let placeholderName = {
                "16:9": "16_9",
                "1:1": "1_1"
            }[this.placeholder];

            return require(`@/assets/img/placeholder_${placeholderName}.png`);
        }
    },

    methods: {
        onError() {
            if (!this.isLazy) {
                // if image is not lazy loaded we want to mark the error immediately
                this.errorLoading = true;
            } else {
                // if image is lazy loaded, we want to wait until it actually tried
                // to load the image (based on the data-loaded attr)
                // to mark the error and make it no longer lazy (so it loads by the original src attr)
                if ($(this.$el).attr("data-loaded")) {
                    this.isLazy = false;
                    this.errorLoading = true;
                }
            }
        }
    },

    watch: {
        url() {
            // restart lazy behavior and
            // trigger a lazy reload when url is updated
            if (this.lazy) this.isLazy = true;

            if (this.isLazy) {
                $(this.$el).removeAttr("data-loaded");
                $(this.$el).attr("src", this.placeholderUrl);
                this.observer.observe();
            }
        }
    }
};
</script>
